import useEmblaCarousel from 'embla-carousel-react';
import { EmblaOptionsType } from 'embla-carousel';
import { DotButton, useDotButton } from './dotButtons';
import Autoplay from 'embla-carousel-autoplay';
import { PrevButton, NextButton, usePrevNextButtons } from './arrowButtons';
import { ReactNode } from 'react';
import useDeviceWidth from '@/hooks/useDeviceWidth';
import clsx from 'clsx';

type Props = {
	children: ReactNode;
	isLoading?: boolean;
	classNameControls?: string;
	classNameContainer?: string;
	classNameEmblaContainer?: string;
};

export const Carousel: React.FC<Props> = ({
	isLoading,
	classNameContainer,
	classNameControls,
	classNameEmblaContainer,
	children,
}) => {
	const OPTIONS: EmblaOptionsType = { loop: true };
	const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS, [
		Autoplay({ playOnInit: false, delay: 3000 }),
	]);

	const { selectedIndex, scrollSnaps, onDotButtonClick } =
		useDotButton(emblaApi);

	const width = useDeviceWidth();
	const isMobile = width < 650;

	const {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	} = usePrevNextButtons(emblaApi);

	return (
		<section className={`embla pl-5 lg:pl-20 ${classNameContainer}`}>
			<div className="embla__viewport" ref={emblaRef}>
				<div className={`embla__container ${classNameEmblaContainer}`}>
					{children}
				</div>
			</div>

			{!isLoading && (
				<div
					className={`embla__controls my-8 pr-5 lg:pr-20 ${classNameControls}`}
				>
					<div className="embla__buttons">
						<PrevButton
							onClick={onPrevButtonClick}
							disabled={prevBtnDisabled}
						/>
						<div className={clsx('embla__dots', { ' !hidden': isMobile })}>
							{scrollSnaps.map((_, index) => (
								<DotButton
									key={index}
									onClick={() => onDotButtonClick(index)}
									className={'embla__dot'.concat(
										index === selectedIndex ? ' embla__dot--selected' : ''
									)}
								/>
							))}
						</div>
						<NextButton
							onClick={onNextButtonClick}
							disabled={nextBtnDisabled}
						/>
					</div>
				</div>
			)}
		</section>
	);
};
